<template>
  <div>
    <factor-tabs :type="type" :pre_factor="isPreFactor"></factor-tabs>
    <m-form
      :title="title"
      :hasIdProp="hasIdProp"
      :showList="false"
      :listRoute="listRoute"
      :exportBaseUrl="isFpi || isCw ? 'reports/lists/factors' : undefined"
      :exportParams="(isFpi || isCw) && { id: this.id }"
      :showClearBtn="!isFpi"
      :showNavigationBtns="!isFpi"
      :showSubmitAndClearBtn="!isFpi"
      :isEditing.sync="isEditing"
      :canDelete="canDelete && !isFpi && (!item.in_moadian || is_invoked)"
      :canEdit="item.is_editable"
      :canSubmit="canSubmit"
      :show-creation-data="!isXs"
      @clearForm="clearForm(true)"
      @goToForm="getItemByPosition"
      @submit="validate"
      @delete="deleteItem()"
    >
      <template #header-btns>
        <open-sanad-btn v-if="item.sanad && !isXs" :sanad="item.sanad" />
        <v-tooltip top color="primary" v-if="item.aggregatedSanad && !isXs">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="factor-aggregated-sanad-btn"
              v-bind="attrs"
              v-on="on"
              icon
              class="primary white--text mr-1"
              depressed
              :to="{ name: 'FactorsAggregatedSanadForm', params: { id: item.aggregatedSanad, type: item.type } }"
            >
              <v-img max-height="20" max-width="20" src="/img/icons/doc.svg"></v-img>
            </v-btn>
          </template>
          سند تجمیعی
        </v-tooltip>
        <v-tooltip top color="primary" v-if="hasTransaction && !isXs">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="factor-show-transactions-btn"
              v-bind="attrs"
              v-on="on"
              icon
              @click="transactionsDialog = true"
              class="back white--text mr-1"
              depressed
            >
              <v-img max-height="20" max-width="20" src="/img/icons/card-coin.svg"></v-img>
            </v-btn>
          </template>
          مشاهده {{ transactionLink.label }} ها
        </v-tooltip>
        <v-tooltip top color="primary" v-if="preFactor != null && !isXs">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="factor-pre-btn"
              v-bind="attrs"
              v-on="on"
              icon
              target="_blank"
              class="back white--text mr-1"
              depressed
              :to="{
                name: 'FactorForm',
                params: { type: preFactor.type, isPreFactor: preFactor.isPreFactor, id: preFactor.id },
              }"
            >
              <v-img max-height="20" max-width="20" src="/img/icons/pre_factor.svg"></v-img>
            </v-btn>
          </template>
          مشاهده {{ preFactor.label }}
        </v-tooltip>
        <v-tooltip top color="primary" v-if="hasTransaction && canSubmitTransaction && !isXs">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="factor-transaction-btn"
              v-bind="attrs"
              v-on="on"
              icon
              target="_blank"
              :to="transactionLink.to"
              class="primary secondary--text mr-1"
              depressed
            >
              <v-img max-height="18" max-width="18" src="/img/icons/recive.svg"></v-img>
            </v-btn>
          </template>
          ثبت {{ transactionLink.label }}
        </v-tooltip>

        <v-tooltip top color="primary" v-if="hasTransaction && canSubmitTransaction && !isXs">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-menu right offset-y v-if="hasTransaction">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    id="factor-fast-transaction-btn"
                    color="back white--text"
                    depressed
                    class="back mr-1"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-img max-height="20" max-width="20" src="/img/icons/money_add.svg"></v-img>
                  </v-btn>
                </template>

                <v-list class="pa-0 pt-1 rounded-lg" v-if="!isXs">
                  <v-list-item
                    class="px-1 pb-1 rounded-lg"
                    v-for="option in quickTransactionOptions"
                    :key="option.codename"
                  >
                    <v-list-item-content class="pa-0">
                      <v-btn @click="createQuickTransaction(option.codename)" block color="secondary white--text"
                        >{{ option.text }}
                      </v-btn>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </span>
          </template>

          ثبت {{ transactionLink.label }} سریع
        </v-tooltip>

        <v-tooltip top color="primary" v-if="hasReverseFactor && !isXs">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="factor-reverse-label-btn"
              class="back secondary--text mr-1"
              @click="reverseFactor"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-img max-width="22" src="/img/icons/back_from_factor.svg"></v-img>
            </v-btn>
          </template>
          ثبت {{ reverseLabel }}
        </v-tooltip>

        <!-- <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="factor-person-btn"
              v-if="!isFpi && !isCw"
              class="back secondary--text mr-1 ml-1"
              @click="personDialog = true"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-img max-height="20" max-width="20" src="/img/icons/plus_user.svg"></v-img>
            </v-btn>
          </template>
          تعریف حساب اشخاص
        </v-tooltip> -->
        <v-tooltip top color="secondary" v-if="!isFpi && !isCw && id != false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="factor-export-btn"
              @click="exportsDialog = true"
              class="secondary mr-1 ml-1"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-img max-height="18" max-width="18" src="/img/icons/file_download.svg"></v-img>
            </v-btn>
          </template>
          خروجی
        </v-tooltip>
      </template>
      <template>
        <v-row style="margin-top: -15px">
          <v-col cols="12" md="9" style="margin-top: -5px">
            <v-row>
              <v-col cols="12" md="2" v-if="!isFpi">
                <div id="factor-number">
                  <v-text-field
                      class="rounded-lg"
                      v-model="item.code"
                      label="شماره "
                      background-color="white"
                  >
                    <template #append>
                      <v-icon  class="mt-1" @click="getItemByCode(item.code)">fa-search</v-icon>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <div id="factor-date">
                  <date
                    label=" * تاریخ"
                    required
                    v-model="item.date"
                    :default="true"
                    :disabled="!isEditing || isConverted"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="2" v-show="false" id="factor-time">
                <div id="factor-time">
                  <mtime
                    label=" * ساعت"
                    required
                    v-model="item.time"
                    :default="true"
                    :disabled="!isEditing || isConverted"
                  />
                </div>
              </v-col>

              <v-col cols="12" md="2" v-if="hasBijak" v-show="false">
                <div id="factor-bijak">
                  <v-text-field
                    class="rounded-lg"
                    label="بیجک"
                    v-model="item.bijak"
                    :disabled="!isEditing || isConverted"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="2"
                     v-if="(isSale || isBackFromSale) && hasModule('distribution')">
                <div id="factor-visitor">
                  <v-autocomplete
                    class="rounded-lg"
                    :return-object="false"
                    label="ویزیتور"
                    :items="factorVisitors"
                    v-model="item.visitor"
                    item-text="user.name"
                    item-value="id"
                    :disabled="!isEditing || backFrom != null || item.backFrom != null || isConverted"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4" v-if="!isProduction">
                <div id="factor-account">
                  <account-select
                    :show-btns="true"
                    :label="' * ' + accountName"
                    :itemsType="accountType"
                    :visitorId="item.visitor"
                    v-model="item.account"
                    :disabled="!isEditing || backFrom != null || item.backFrom != null || isConverted"
                    :floatAccount1.sync="item.floatAccount1"
                    :floatAccount2.sync="item.floatAccount2"
                    :floatAccount3.sync="item.floatAccount3"
                    :floatAccount4.sync="item.floatAccount4"
                  />
                </div>
              </v-col>
              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    id="factor-person-btn"
                    v-if="!isFpi && !isCw"
                    class="back secondary--text mr-1 ml-1"
                    @click="personDialog = true"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                  <v-img max-height="20" max-width="20" src="/img/icons/plus_user.svg"></v-img>
                  </v-btn>
                </template>
                 تعریف حساب اشخاص
              </v-tooltip>
              <v-col cols="12" md="2" v-if="isBuy">
                <div id="factor-seller-number">
                  <v-text-field
                    class="rounded-lg"
                    label="شماره فاکتور فروشنده"
                    v-model="item.seller_factor_code"
                    :disabled="!isEditing || isConverted"
                  />
                </div>
              </v-col>

              <v-col cols="12" md="2" v-if="showTax" style="margin-top: -15px" v-show="false" id="factor-has-tax">
                <v-switch
                  inset
                  color="success"
                  label="فاکتور مالیات دارد"
                  v-model="item.has_tax"
                  @change="removeTax(item.has_tax)"
                  :disabled="!isEditing || isConverted"
                ></v-switch>
              </v-col>

              <v-col cols="12" md="2" v-if="showTax && !isPreFactor" id="factor-has-auto-sanad"
                     style="margin-top: -15px" v-show="false">
                <v-switch
                  inset
                  color="success"
                  label="سند خودکار"
                  v-model="item.has_auto_sanad"
                  :disabled="!isEditing || item.sanad != null"
                ></v-switch>
              </v-col>
              <v-col v-show="false" cols="12" md="2" v-if="isPreFactor" style="margin-top: -15px">
                <v-switch inset color="success" label="سند خودکار" v-model="item.has_auto_sanad"></v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3">
            <v-row>
              <v-col cols="12" style="margin-top: -5px">
                <div id="factor-explanation">
                  <v-textarea
                    class="rounded-lg"
                    label="شرح"
                    v-model="item.explanation"
                    :disabled="!isEditing || isConverted"
                    @keyup.enter.stop
                    height="90"
                    :auto-grow="true"
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row  v-show="!isXs">
          <v-col cols="12">
            <m-datatable
                v-if="isFpi"
                :show-filter-row="false"
                :fixed_header="true"
                :height="inputTableHeight"
                :headers="fpi_headers"
                :items="rows"
                :showExportBtns="false"
                :showAppliedFilters="false"
                :showClearFiltersBtn="true"
                :showSelect="false"
                :filters.sync="filters"
            >
              <template style="width: 150px" #item.ware.name="{ item }">
                <ware-select
                    :show-info="false"
                    v-model="item.ware"
                    :disabled="!isEditing || item.factorItem"
                    :factorType="type"
                    :show-main-unit="false"
                    :account="item.account"
                    :has-sale-prices="true"
                    :float-account="item.floatAccount"
                    :cost-center="item.costCenter"
                    :isService="getIsService()"
                    @change="clearRow(item)"
                />
              </template>
              <template style="width: 150px" #item.unit.name="{ item }">
                <v-autocomplete
                    class="rounded-lg"
                    v-if="item.ware"
                    :items="getWareUnits(item.ware)"
                    v-model="item.unit"
                    :title="getUnitSuffix(item.ware, item.unit)"
                    @change="updateRowFee(item)"
                    item-text="name"
                    item-value="id"
                    :disabled="!isEditing || item.factorItem"
                    :return-object="true"
                ></v-autocomplete>
              </template>
              <template style="width: 150px" #item.warehouse.name="{ item }">
                  <v-autocomplete
                      class="rounded-lg"
                      :return-object="true"
                      v-if="item.ware && !item.ware.is_service"
                      v-model="item.warehouse"
                      :disabled="!isEditing || item.factorItem"
                      :items="warehouses"
                      item-text="title"
                      item-value="id"
                  ></v-autocomplete>
                  <span v-else>-</span>
              </template>
              <template style="width: 150px" #item.unit_count="{ item }">
                <money
                    v-model="item.unit_count"
                    :disabled="!isEditing || item.factorItem"
                />
              </template>
              <template style="width: 150px" #item.fee="{ item }">
                <v-menu
                    class="rounded-lg"
                    bottom
                    offset-y
                    left
                    v-if="isSale || isBackFromBuy"
                    v-model="priceMenus[item.index]"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex flex-row">
                      <money
                          @change="updateRowTaxValue(rows[i])"
                          v-model="item.fee"
                          :disabled="!isEditing || item.factorItem"
                          v-bind="attrs"
                          v-on="on"
                          @click:suffix="priceMenus[item.index] = true"
                          :title="getFeeSuffix(item)"
                      />
                    </div>
                  </template>
                  <v-list class="py-0 rounded-lg">
                    <v-list-item
                        v-for="(price, j) in getWarePrices(item)"
                        :key="j"
                        class="rounded-lg pa-0"
                        @click="item.fee = price.price ; updateRowTaxValue(item)"
                    >
                      <v-list-item-content class="py-1 px-0">
                        <v-list-item-title style="font-size: 12px" class="text-center">
                          <span>{{ price.name }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-center">
                          <span>{{ price.price | toMoney }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <money
                    @click="updateRowTaxValue(item)"
                    v-else
                    v-model="item.fee"
                    :disabled="!isEditing || item.factorItem"
                />
              </template>
              <template #item.total="{ item }">
                <money :value="rowSum(item)" disabled :decimalScale="0" />
              </template>
              <template #item.explanation="{ item }">
                <row-textarea
                    v-model="item.explanation"
                    :disabled="!isEditing || item.factorItem"
                    :i="rows.indexOf(item)"
                    @updateRowsExplanation="updateRowsExplanation"
                />
              </template>
              <template #item.deleteRow="{ item }">
                <v-btn
                    v-if="i != rows.length - 1"
                    @click="deleteItemRow(rows.indexOf(item))"
                    class="error-text"
                    icon
                    :disabled="!isEditing || item.factorItem"
                >
                  <v-icon color="error">delete</v-icon>
                </v-btn>
              </template>
              <template #body.append="{ headers }">
                <tr>
                  <td class="text-center white--text secondary" colspan="1">
                    <v-btn
                        id="factor-delete-rows-btn"
                        class="rounded-lg error white--text pt-4 pb-4"
                        depressed
                        @click="deleteItemRow(-1)"
                        :disabled="!isEditing"
                    >
                      حذف همه ردیف ها
                    </v-btn>
                  </td>
                  <td class="text-center white--text primary--text secondary" colspan="3">جمع کل</td>
                  <td class="text-center white--text secondary">{{ sum.count | toMoney(0) }}</td>
                  <td class="text-center white--text secondary"></td>
                  <td class="text-center white--text secondary">{{ sum.sum | toMoney(0) }}</td>
                  <td class="text-center white--text secondary"></td>
                  <td class="text-center white--text secondary"></td>
                </tr>
              </template>

            </m-datatable>

            <input-table
              v-show="!isFpi"
              v-model="rows"
              id="input-table"
              style="margin-top: -30px"
              :height="inputTableHeight"
              :fixed_header="true"
            >
              <template #thead>
                <tr>
                  <th class="tableHeader secondary--text" v-if="hasSelect" style="width: 24px"></th>
                  <th class="tableHeader secondary--text" style="width: 32px">#</th>
                  <th class="tableHeader secondary--text" style="width: 250px">* نام کالا</th>
                  <th class="tableHeader secondary--text" style="width: 32px"></th>
                  <th class="tableHeader secondary--text" style="width: 64px">* واحد</th>
                  <th class="tableHeader secondary--text">* انبار</th>
                  <th class="tableHeader secondary--text" style="width: 70px">* تعداد</th>
                  <th class="tableHeader secondary--text" v-if="showCalculatorBtn" style="width: 30px !important"></th>

                  <template v-if="!isCw && !isRoR">
                    <th class="tableHeader secondary--text" style="width: 85px">* قیمت واحد</th>
                    <th class="tableHeader secondary--text">مبلغ کل</th>
                  </template>

                  <th class="tableHeader secondary--text"
                      v-if="showDiscount" style="width: 40px">درصد تخفیف</th>
                  <th class="tableHeader secondary--text" v-if="showDiscount">
                    مبلغ تخفیف</th>
                  <th class="tableHeader secondary--text" v-if="showDiscount">
                    جمع کل پس از تخفیف</th>

                  <template v-if="showTax && rowsHaveTax">
                    <th class="tableHeader secondary--text" style="width: 40px">درصد مالیات</th>
                    <th class="tableHeader secondary--text">مبلغ مالیات</th>
                    <th class="tableHeader secondary--text">جمع مبلغ کل و مالیات</th>
                  </template>

                  <th class="tableHeader secondary--text">توضیحات</th>
                  <th class="tableHeader" style="width: 32px">
                    <v-icon color="secondary" x-small>fa-trash</v-icon>
                  </th>
                </tr>
              </template>
              <template #tbody>
                <tr
                  v-for="(row, i) in rows"
                  :key="i"
                  :class="{ 'd-print-none': i == rows.length - 1, draggable: i != rows.length - 1 && isEditing }"
                >
                  <td v-if="hasSelect">
                    <v-btn
                      v-if="row.factorItem"
                      color="secondary"
                      class="mx-1 rounded-lg"
                      depressed
                      dir="ltr"
                      :title="getFactorItemLink(row).title"
                      icon
                      outlined
                      :to="getFactorItemLink(row).to"
                      target="_blank"
                      >{{ getFactorItemLink(row).text }}
                    </v-btn>
                    <v-checkbox v-else v-model="row.is_selected" class="mr-1" :disabled="isEditing"></v-checkbox>
                  </td>
                  <td class="tr-counter">{{ i + 1 }}</td>
                  <td>
                    <div id="factor-row-ware">
                      <ware-select
                        :show-info="!isFpi"
                        v-model="rows[i].ware"
                        :disabled="!isEditing || row.factorItem"
                        :factorType="type"
                        :show-main-unit="false"
                        :account="item.account"
                        :has-sale-prices="true"
                        :float-account="item.floatAccount"
                        :cost-center="item.costCenter"
                        :isService="getIsService()"
                        @change="clearRow(i)"
                      />
                    </div>
                  </td>
                  <td>
                    <v-btn
                      v-show="false"
                      icon
                      color="back"
                      :disabled="!item.account || !item.account.id || !rows[i].ware"
                      @click="showPrices(rows[i].ware)"
                    >
                      <v-img
                        v-if="!item.account || !item.account.id || !rows[i].ware"
                        max-width="25"
                        src="/img/icons/price_disable.svg"
                      ></v-img>
                      <v-img v-else max-width="25" src="/img/icons/price.svg"></v-img>
                    </v-btn>
                  </td>
                  <td id="factor-row-unit">
                    <v-autocomplete
                      class="rounded-lg"
                      v-if="rows[i].ware"
                      :items="getWareUnits(rows[i].ware)"
                      v-model="rows[i].unit"
                      :title="getUnitSuffix(row.ware, row.unit)"
                      @change="updateRowFee(rows[i])"
                      item-text="name"
                      item-value="id"
                      :disabled="!isEditing || row.factorItem"
                      :return-object="true"
                    ></v-autocomplete>
                  </td>
                  <td id="factor-row-warehouse" class="tr-warehouse"
                      :title="rows[i].warehouse && rows[i].warehouse.title">
                    <v-autocomplete
                      class="rounded-lg"
                      :return-object="true"
                      v-if="rows[i].ware && !rows[i].ware.is_service"
                      v-model="rows[i].warehouse"
                      :disabled="!isEditing || row.factorItem"
                      :items="warehouses"
                      item-text="title"
                      item-value="id"
                    ></v-autocomplete>
                    <span v-else>-</span>
                  </td>
                  <td id="factor-row-unit-count">
                    <money
                      v-model="rows[i].unit_count"
                      :disabled="!isEditing || row.factorItem"
                    />
                  </td>
                  <td v-if="showCalculatorBtn">
                    <v-btn depressed icon @click="openCalculatorDialog(row)">
                      <v-icon>fa-calculator</v-icon>
                    </v-btn>
                  </td>
                  <template v-if="!isCw && !isRoR">
                    <td id="factor-row-fee">
                      <v-menu
                        class="rounded-lg"
                        bottom
                        offset-y
                        left
                        v-if="isSale || isBackFromBuy"
                        v-model="priceMenus[i]"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex flex-row">
                            <money
                              @change="updateRowTaxValue(rows[i])"
                              v-model="rows[i].fee"
                              :disabled="!isEditing || row.factorItem"
                              v-bind="attrs"
                              v-on="on"
                              @click:suffix="priceMenus[i] = true"
                              :title="getFeeSuffix(row)"
                            />
                          </div>
                        </template>

                        <v-list class="py-0 rounded-lg">
                          <v-list-item
                            v-for="(price, j) in getWarePrices(rows[i])"
                            :key="j"
                            class="rounded-lg pa-0"
                            @click="rows[i].fee = price.price ; updateRowTaxValue(rows[i])"
                          >
                            <v-list-item-content class="py-1 px-0">
                              <v-list-item-title style="font-size: 12px" class="text-center">
                                <span>{{ price.name }}</span>
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-center">
                                <span>{{ price.price | toMoney }}</span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <money
                        @click="updateRowTaxValue(rows[i])"
                        v-else
                        v-model="rows[i].fee"
                        :disabled="!isEditing || row.factorItem"
                      />
                    </td>
                    <td dir="ltr" id="factor-row-sum">
                      <money :value="rowSum(rows[i])" disabled :decimalScale="0" />
                    </td>
                  </template>

                  <template v-if="showDiscount">
                    <td id="factor-row-discount-percent">
                      <v-text-field
                        class="rounded-lg"
                        :disabled="!isEditing || row.factorItem"
                        type="number"
                        min="0"
                        max="100"
                        @change="rows[i].discountPercent = Math.max(Math.min(rows[i].discountPercent, 100), 0)"
                        v-model="rows[i].discountPercent"
                        prefix="%"
                        @input="updateRowDiscountValue(row)"
                      />
                    </td>
                    <td id="factor-row-discount-value">
                      <money
                        :disabled="!isEditing || row.factorItem"
                        v-model="rows[i].discountValue"
                        @input="updateRowDiscountPercent(row)"
                      />
                    </td>
                    <td id="factor-row-after-discount">
                      <money
                        :value="rowSumAfterDiscount(row)"
                        :decimalScale="0"
                        disabled
                      />
                    </td>
                  </template>
                  <template v-if="showTax && rowsHaveTax">
                    <td>
                      <v-text-field
                        class="rounded-lg"
                        :disabled="!isEditing || row.factorItem"
                        type="number"
                        min="0"
                        max="100"
                        step="1"
                        @change="rows[i].tax_percent = Math.max(Math.min(Math.round(rows[i].tax_percent), 100), 0)"
                        v-model="rows[i].tax_percent"
                        prefix="%"
                        @input="updateRowTaxValue(row)"
                      />
                    </td>
                    <td>
                      <money
                        :disabled="!isEditing || row.factorItem"
                        v-model="rows[i].tax_value"
                        @input="updateRowTaxPercent(row)"
                      />
                    </td>
                    <td>
                      <money :decimalScale="0" :value="rowSumAfterTax(row)" disabled />
                    </td>
                  </template>

                  <td id="factor-row-explanation">
                    <row-textarea
                      v-model="rows[i].explanation"
                      :disabled="!isEditing || row.factorItem"
                      :i="i"
                      @updateRowsExplanation="updateRowsExplanation"
                    />
                  </td>
                  <td class="d-print-none" id="factor-row-delete">
                    <v-btn
                      v-if="i != rows.length - 1"
                      @click="deleteItemRow(i)"
                      class="error-text"
                      icon
                      :disabled="!isEditing || row.factorItem"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>

                <tr v-if="showOldUi" class="back text--secondary">
                  <td v-if="hasSelect"></td>
                  <td colspan="4"></td>

                  <td v-if="isFpi">{{ rowsSum("count") | toMoney(0) }}</td>
                  <td v-else></td>

                  <td v-if="!isCw && !isRoR"></td>

                  <td v-if="isFpi">{{ sum.sum | toMoney(0) }}</td>
                  <td v-else></td>

                  <td v-if="isProduction"></td>

                  <td></td>
                  <td v-if="showDiscount" colspan="4"></td>
                  <td v-if="showTax && rowsHaveTax" colspan="3"></td>
                  <td>
                    <v-btn @click="deleteItemRow(-1)" icon class="error--text" :disabled="!isEditing">
                      <v-icon>delete_sweep</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template #footer v-if="!showOldUi">
                <tr v-if="!isFpi && !isRoR && !isCw">
                  <th class="primary--text secondary" v-if="isPreFactor"></th>
                  <th class="secondary pr-1" colspan="3">
                    <v-btn
                      id="factor-delete-rows-btn"
                      class="rounded-lg error white--text pt-4 pb-4"
                      depressed
                      @click="deleteItemRow(-1)"
                      :disabled="!isEditing"
                    >
                      حذف همه ردیف ها
                    </v-btn>
                    <v-btn
                      id="factor-expense-btn"
                      class="rounded-lg primary white--text mr-2 pt-4 pb-4"
                      depressed
                      v-if="!isCw && !isRoR && showFactorExpenses"
                      @click="openFactorExpensesDialog"
                    >
                      هزینه های فاکتور
                    </v-btn>
                    <v-btn
                      id="factor-discount-btn"
                      class="rounded-lg info white--text mr-2 pt-4 pb-4"
                      depressed
                      v-if="!isCw && !isRoR"
                      :disabled="!isEditing"
                      @click="discountDialog = true"
                    >
                      تخفیف کلی
                    </v-btn>
                  </th>
                  <th colspan="2" class="text-center primary--text secondary">جمع کل فاکتور</th>
                  <th class="text-center white--text secondary">{{ sum.count | toMoney(0) }}</th>
                  <th class="text-center white--text secondary"></th>
                  <th class="text-center white--text secondary">{{ totalAmount | toMoney(0) }}</th>
                  <th class="text-center white--text secondary"></th>
                  <th class="text-center white--text secondary">{{ rowsSum("discountValue") | toMoney(0) }}</th>
                  <th class="text-center white--text secondary">{{ totalAfterDiscountValue | toMoney(0) }}</th>
                  <th class="text-center white--text secondary" v-if="showTax && rowsHaveTax"></th>
                  <th class="text-center white--text secondary" v-if="showTax && rowsHaveTax">
                    {{ rowsSum("tax_value") | toMoney(0) }}
                  </th>
                  <th class="text-center white--text secondary" v-if="showTax && rowsHaveTax">
                    {{ sum.sum | toMoney(0) }}
                  </th>
                  <th class="text-center white--text secondary"></th>
                  <th class="text-center white--text secondary"></th>
                </tr>

                <tr v-if="isFpi">
                  <td class="text-center white--text secondary" colspan="1">
                    <v-btn
                      id="factor-delete-rows-btn"
                      class="rounded-lg error white--text pt-4 pb-4"
                      depressed
                      @click="deleteItemRow(-1)"
                      :disabled="!isEditing"
                    >
                      حذف همه ردیف ها
                    </v-btn>
                  </td>
                  <td class="text-center white--text primary--text secondary" colspan="4">جمع کل</td>
                  <td class="text-center white--text secondary">{{ sum.count | toMoney(0) }}</td>
                  <td class="text-center white--text secondary"></td>
                  <td class="text-center white--text secondary">{{ sum.sum | toMoney(0) }}</td>
                  <td class="text-center white--text secondary"></td>
                  <td class="text-center white--text secondary"></td>
                </tr>

                <tr v-if="isRoR || isCw">
                  <td class="text-center white--text secondary"></td>
                  <td class="text-center white--text secondary" v-if="!isCw"></td>
                  <td class="text-center white--text secondary primary--text" colspan="4">جمع کل</td>
                  <td class="text-center white--text secondary">{{ sum.count | toMoney(0) }}</td>
                  <td class="text-center white--text secondary"></td>
                  <td class="text-center white--text secondary"  id="factor-delete-rows-btn">
                    <v-btn
                        class="error--text"
                        icon
                        @click="deleteItemRow(-1)"
                        :disabled="!isEditing"
                    >
                      <v-icon>delete_sweep</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </input-table>
          </v-col>
        </v-row>

        <template v-if="isXs">
          <v-row>
            <v-btn
              @click="
                mobileNewRowDialogTitle = 'ثبت کالا';
                mobileNewRowDialog = true;
                mobileRow = rows[rows.length - 1];
              "
              fab
              class="rounded-lg success white--text"
              depressed
              :disabled="!isEditing"
            >
              <v-icon>fa-plus</v-icon>
            </v-btn>
            <v-btn
              class="rounded-lg error white--text mr-2"
              depressed
              fab
              @click="mobileDeleteAllRowDialog = true"
              :disabled="!isEditing"
            >
              <v-icon>fa-trash</v-icon>
            </v-btn>

            <v-btn
              class="rounded-lg info white--text mr-2"
              depressed
              fab
              v-if="!isCw && !isRoR"
              :disabled="!isEditing"
              @click="discountDialog = true"
            >
              <v-icon>fa-percent</v-icon>
            </v-btn>
          </v-row>
          <v-row v-if="!isCw && !isRoR">
            <v-col cols="12">
              <v-card class="rounded-lg back secondary--text" width="100%">
                <v-card-subtitle class="white--text" style="font-size: x-small">
                  <span class="secondary--text" style="font-weight: bold"> مبلغ کل : </span>
                  <span class="mr-1 lightSecondary--text">
                    {{ totalAmount | toMoney(0) }}
                  </span>
                  <span class="mr-3 secondary--text" style="font-weight: bold"> مبلغ تخفیف : </span>
                  <span class="mr-1 lightSecondary--text">
                    {{ rowsSum("discountValue") | toMoney(0) }}
                  </span>
                  <span class="mr-3 secondary--text" style="font-weight: bold"> جمع کل پس از تخفیف : </span>
                  <span class="mr-1 lightSecondary--text">
                    {{ totalAfterDiscountValue | toMoney(0) }}
                  </span>
                  <br v-if="showTax && rowsHaveTax" />
                  <span v-if="showTax && rowsHaveTax" class="secondary--text" style="font-weight: bold"> مبلغ مالیات : </span>
                  <span v-if="showTax && rowsHaveTax" class="mr-1 lightSecondary--text">
                    {{ rowsSum("tax_value") | toMoney(0) }}
                  </span>
                  <span v-if="showTax && rowsHaveTax" class="mr-3 secondary--text" style="font-weight: bold">
                    جمع مبلغ کل و مالیات :
                  </span>
                  <span v-if="showTax && rowsHaveTax" class="mr-1 lightSecondary--text">
                    {{ sum.sum | toMoney(0) }}
                  </span>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-for="(row, i) in rows" :key="i" v-if="i != rows.length - 1">
            <v-col cols="12">
              <v-card
                class="rounded-lg secondary white--text"
                width="100%"
                @click="
                  mobileNewRowDialogTitle = 'ویرایش کالا ';
                  mobileNewRowDialog = true;
                  mobileRow = row;
                  mobileRowIndex = i;
                "
              >
                <v-card-subtitle class="white--text" style="font-size: x-small" v-if="rows[i].ware">
                  <span>
                    {{ rows[i].ware.name }}
                  </span>
                  <span class="mr-1 primary--text">
                    {{ rows[i].unit_count | toMoney(0) }}
                  </span>
                  <span v-if="rows[i].unit" class="mr-1">
                    {{ rows[i].unit.name }}
                  </span>
                  <template v-if="!isCw && !isRoR">
                    <span class="mr-5"> قیمت : </span>
                    <span class="mr-1 primary--text">
                      {{ rows[i].fee | toMoney(0) }}
                    </span>
                    <span class="mr-2"> جمع : </span>
                    <span class="mr-1 primary--text">
                      {{ rowSum(rows[i]) | toMoney(0) }}
                    </span>
                  </template>
                  <template v-else>
                    <span class="mr-5"> انبار : </span>
                    <span v-if="rows[i].warehouse" class="mr-1 primary--text">
                      {{ rows[i].warehouse.name }}
                    </span>
                  </template>
                  <v-img class="float-left" src="/img/icons/more.svg" width="20" height="20"></v-img>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>

          <v-dialog v-if="mobileRow" v-model="mobileNewRowDialog" max-width="500px" class="rounded-lg">
            <v-card class="rounded-lg">
              <v-toolbar flat class="rounded-lg white--text" color="secondary" dark>
                <v-icon class="ml-2">fa-plus</v-icon>
                {{ mobileNewRowDialogTitle }}
              </v-toolbar>
              <v-card-text>
                <v-row class="mt-3">
                  <v-col cols="12">
                    <ware-select
                      label="نام کالا"
                      :disabled="!isEditing"
                      :factorType="type"
                      :show-main-unit="false"
                      v-model="mobileRow.ware"
                      @change="mobileRow.tax_percent = mobileRow.ware.value_added_tax"
                      :isService="getIsService()"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="mobileRow.ware">
                  <v-col :cols="!mobileRow.ware.is_service ? 6 : 12">
                    <v-autocomplete
                      class="rounded-lg"
                      :items="getWareUnits(mobileRow.ware)"
                      v-model="mobileRow.unit"
                      label="واحد"
                      @change="updateRowFee(mobileRow)"
                      item-text="name"
                      item-value="id"
                      :disabled="!isEditing"
                      :return-object="true"
                      :suffix="getUnitSuffix(mobileRow.ware, mobileRow.unit)"
                    ></v-autocomplete>
                  </v-col>
                  <v-col v-if="!mobileRow.ware.is_service" cols="6">
                    <v-autocomplete
                      label="انبار"
                      class="rounded-lg"
                      :return-object="true"
                      v-model="mobileRow.warehouse"
                      :disabled="!isEditing"
                      :items="warehouses"
                      item-text="title"
                      item-value="id"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="mobileRow.ware && !mobileRow.ware.is_service"> </v-row>
                <v-row>
                  <v-col :cols="!isCw && !isRoR ? 6 : 12">
                    <money label="تعداد" v-model="mobileRow.unit_count" :disabled="!isEditing" />
                  </v-col>

                  <v-col v-if="!isCw && !isRoR" cols="6">
                    <v-menu
                      class="rounded-lg"
                      bottom
                      offset-y
                      left
                      v-if="isSale || isBackFromBuy"
                      v-model="priceMenus[rows.length - 1]"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div class="d-flex flex-row">
                          <money
                            label="قیمت واحد"
                            v-model="mobileRow.fee"
                            :disabled="!isEditing"
                            v-bind="attrs"
                            v-on="on"
                            @click:suffix="priceMenus[rows.length - 1] = true"
                            :title="getFeeSuffix(mobileRow)"
                          />
                        </div>
                      </template>

                      <v-list class="py-0 rounded-lg">
                        <v-list-item
                          v-for="(price, j) in getWarePrices(mobileRow)"
                          :key="j"
                          class="rounded-lg pa-0"
                          @click="mobileRow.fee = price.price"
                        >
                          <v-list-item-content class="py-1 px-0">
                            <v-list-item-title style="font-size: 12px" class="text-center">
                              <span>{{ price.name }}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-center">
                              <span>{{ price.price | toMoney }}</span>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <money v-else label="قیمت واحد" v-model="mobileRow.fee" :disabled="!isEditing" />
                  </v-col>

                  <v-col cols="12" v-if="!isCw && !isRoR">
                    <money label="مبلغ کل" :value="rowSum(mobileRow)" disabled :decimalScale="0" />
                  </v-col>
                </v-row>
                <template v-if="showDiscount">
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        class="rounded-lg"
                        :disabled="!isEditing"
                        type="number"
                        min="0"
                        max="100"
                        label="درصد تخفیف"
                        @change="mobileRow.discountPercent = Math.max(Math.min(mobileRow.discountPercent, 100), 0)"
                        v-model="mobileRow.discountPercent"
                        prefix="%"
                        @input="updateRowDiscountValue(mobileRow)"
                      />
                    </v-col>
                    <v-col cols="6">
                      <money
                        label="مبلغ تخفیف"
                        :disabled="!isEditing || mobileRow.factorItem"
                        v-model="mobileRow.discountValue"
                        @input="updateRowDiscountPercent(mobileRow)"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <money
                        label="جمع کل پس از تخفیف"
                        :value="rowSumAfterDiscount(mobileRow)"
                        :decimalScale="0"
                        disabled
                      />
                    </v-col>
                  </v-row>
                </template>

                <template v-if="mobileRow.ware && mobileRow.ware.value_added_tax">
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        class="rounded-lg"
                        :disabled="!isEditing || mobileRow.factorItem"
                        type="number"
                        min="0"
                        max="100"
                        step="1"
                        @change="mobileRow.tax_percent = Math.max(Math.min(Math.round(mobileRow.tax_percent), 100), 0)"
                        v-model="mobileRow.tax_percent"
                        prefix="%"
                        label="درصد مالیات"
                        @input="updateRowTaxValue(mobileRow)"
                      />
                    </v-col>
                    <v-col cols="6">
                      <money
                        label="مبلغ مالیات"
                        :disabled="!isEditing || mobileRow.factorItem"
                        v-model="mobileRow.tax_value"
                        @input="updateRowTaxPercent(mobileRow)"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <money
                        label="جمع مبلغ کل و مالیات"
                        :decimalScale="0"
                        :value="rowSumAfterTax(mobileRow)"
                        disabled
                      />
                    </v-col>
                  </v-row>
                </template>
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      class="rounded-lg"
                      label="توضیحات"
                      v-model="mobileRow.explanation"
                      :disabled="!isEditing || mobileRow.factorItem"
                      @updateRowsExplanation="updateRowsExplanation"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-btn
                    @click="mobileNewRowDialog = false"
                    block
                    :disabled="!isEditing"
                    depressed
                    class="success white--text rounded-lg pt-5 pb-5"
                    >ثبت
                  </v-btn>
                </v-row>
                <v-row class="mt-5" v-if="mobileNewRowDialogTitle != 'ثبت کالا'">
                  <v-btn
                    @click="mobileDeleteRowDialog = true"
                    block
                    depressed
                    :disabled="!isEditing"
                    class="error white--text rounded-lg pt-5 pb-5"
                    >حذف
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="mobileDeleteAllRowDialog"
            class="rounded-lg"
            persistent
            @click:outside="mobileDeleteAllRowDialog = false"
            max-width="400"
          >
            <v-card class="rounded-lg">
              <v-card-title class="error white--text"> توجه! </v-card-title>
              <v-card-text>
                <v-row class="mt-5 mr-10"> آیا مایل به حذف همه ردیف ها هستید؟ </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" depressed class="rounded-lg" @click="mobileDeleteAllRowDialog = false">
                  خیر
                </v-btn>
                <v-btn
                  color="error"
                  depressed
                  class="rounded-lg"
                  @click="
                    deleteItemRow(-1);
                    mobileDeleteAllRowDialog = false;
                  "
                >
                  بله
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="mobileDeleteRowDialog"
            class="rounded-lg"
            persistent
            @click:outside="mobileDeleteRowDialog = false"
            max-width="400"
          >
            <v-card class="rounded-lg">
              <v-card-title class="error white--text"> توجه! </v-card-title>
              <v-card-text>
                <v-row class="mt-5 mr-10"> آیا مایل به حذف این ردیف هستید؟ </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" depressed class="rounded-lg" @click="mobileDeleteRowDialog = false"> خیر </v-btn>
                <v-btn
                  color="error"
                  depressed
                  class="rounded-lg"
                  @click="
                    deleteItemRow(mobileRowIndex);
                    mobileNewRowDialog = false;
                    mobileRowIndex = null;
                    mobileDeleteRowDialog = false;
                  "
                >
                  بله
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <v-row v-if="!isCw && !isRoR" v-show="showOldUi">
          <v-col cols="12" md="8">
            <div v-if="showFactorExpenses" class="pa-1 ml-md-5 rounded-lg" style="border: 1px dashed #50cd89">
              <div class="d-flex">
                <h3 class="success--text mt-1 mr-1">هزینه های فاکتور</h3>
                <v-spacer></v-spacer>
              </div>
              <input-table v-model="item.expenses" class="mt-3">
                <template #thead>
                  <tr>
                    <th>ردیف</th>
                    <th>نام هزینه ثابت</th>
                    <th>مبلغ</th>
                    <th>پرداخت کننده</th>

                    <th>حساب شناور</th>
                    <th>توضیحات</th>
                  </tr>
                </template>
                <template #tbody v-if="item.expenses.length">
                  <tr v-for="(e, i) in item.expenses" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ e.expense.name }}</td>
                    <td>{{ e.value | toMoney }}</td>
                    <td>{{ e.account.title }}</td>
                    <td>{{ e.floatAccount ? e.floatAccount.name : " - " }}</td>
                    <td>{{ e.explanation }}</td>
                  </tr>
                  <tr class="back secondary--text">
                    <td colspan="2" class="success--text">جمع هزینه های فاکتور:</td>
                    <td>{{ sum.expenses | toMoney }}</td>
                    <td colspan="4"></td>
                  </tr>
                </template>
                <tbody v-else>
                  <tr>
                    <td colspan="7">هزینه ای ثبت نشده است</td>
                  </tr>
                </tbody>
              </input-table>
              <div class="d-flex mt-2">
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  @click="openFactorExpensesDialog"
                  class="primary white--text rounded-lg"
                  :disabled="!isEditing"
                  >افزودن / ویرایش
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-simple-table bordered class="finals">
              <tbody>
                <tr v-if="showDiscount || showTax">
                  <td>جمع:</td>
                  <td colspan="2">{{ sum.sum | toMoney(0) }} ریال</td>
                </tr>
                <tr v-if="showDiscount">
                  <td>تخفیف</td>
                  <td>
                    <money :disabled="!isEditing" v-model="item.discountValue" placeholder="مبلغ" />
                  </td>
                </tr>
                <tr v-if="showDiscount">
                  <td>مبلغ فاکتور پس از تخفیف:</td>
                  <td colspan="2">{{ sum.afterDiscount | toMoney(0) }} ریال</td>
                </tr>
                <tr v-if="showTax && rowsHaveTax">
                  <td>مالیات</td>
                  <td colspan="2">
                    <money :disabled="!isEditing" v-model="item.taxValue" placeholder="مبلغ" />
                  </td>
                </tr>
                <tr>
                  <td>مبلغ کل فاکتور:</td>
                  <td colspan="2">{{ sum.total | toMoney(0) }} ریال</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>

        <v-dialog v-model="factorExpensesDialog" persistent scrollable max-width="1200px">
          <v-card class="form-fields rounded-lg">
            <v-toolbar flat class="ma-1 rounded-lg white--text" color="secondary" dark>هزینه های فاکتور</v-toolbar>

            <v-card-text class="mt-3">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>* نام هزینه ثابت</th>
                    <th>* مبلغ</th>
                    <th>* پرداخت کننده</th>
                    <th>توضیحات</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(e, i) in factorExpensesCopy" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <v-autocomplete
                        :disabled="!isEditing"
                        class="rounded-lg"
                        :return-object="true"
                        :items="factorExpenses.filter((o) => o.type == factorExpenseType)"
                        v-model="e.expense"
                        item-text="name"
                        item-value="id"
                      ></v-autocomplete>
                    </td>
                    <td>
                      <money :disabled="!isEditing" v-model="e.value" />
                    </td>
                    <td>
                      <account-select
                        :disabled="!isEditing"
                        :horizontal="true"
                        itemsType="level3"
                        label
                        v-model="e.account"
                        :floatAccount1.sync="e.floatAccount1"
                        :floatAccount2.sync="e.floatAccount2"
                        :floatAccount3.sync="e.floatAccount3"
                        :floatAccount4.sync="e.floatAccount4"
                      />
                    </td>
                    <td>
                      <v-textarea
                        :disabled="!isEditing"
                        v-model="e.explanation"
                        rows="1"
                        auto-grow
                        class="rounded-lg"
                      />
                    </td>
                    <td>
                      <v-btn
                        :disabled="!isEditing"
                        v-if="i != factorExpensesCopy.length - 1"
                        @click="deleteExpenseRow(i)"
                        class="error--text"
                        icon
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click="addExpenses()" class="success rounded-lg white--text">تایید</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="exportsDialog" scrollable max-width="600px" class="rounded-lg">
          <v-card class="rounded-lg">
            <v-toolbar flat class="ma-1 rounded-lg white--text" color="secondary" dark>خروجی فاکتور</v-toolbar>

            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" md="6">
                  <v-switch
                    inset
                    color="success"
                    label="خلاصه کردن فاکتور"
                    v-model="exportOptions.summarized"
                  ></v-switch>
                  <v-switch
                    inset
                    color="success"
                    label="مخفی کردن هزینه های فاکتور"
                    v-model="exportOptions.hide_expenses"
                  ></v-switch>
                  <v-switch
                    inset
                    color="success"
                    label="مخفی کردن مانده حساب"
                    v-model="exportOptions.hide_remain"
                  ></v-switch>
                  <v-switch
                    inset
                    color="success"
                    label="نمایش متون پیشفرض"
                    v-model="exportOptions.show_default_text"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="mt-1">
                    <v-col cols="12" md="6">
                      <v-btn
                        class="export-btn rounded-lg secondary--text"
                        depressed
                        :href="exportLinks.item.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        block
                      >
                        <v-img class="ml-3" max-height="25" max-width="25" src="/img/icons/print_icon.svg"></v-img>
                        چاپ
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-btn
                        class="export-btn rounded-lg secondary--text"
                        depressed
                        :href="exportLinks.item.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        block
                      >
                        <v-img class="ml-3" max-height="25" max-width="25" src="/img/icons/pdf.svg"></v-img>
                        PDF
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-btn
                        class="export-btn rounded-lg secondary--text"
                        depressed
                        :href="exportLinks.receipt.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        block
                      >
                        <v-img class="ml-3" max-height="25" max-width="25" src="/img/icons/print_icon.svg"></v-img>
                        چاپ {{ receiptLabel }}
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-btn
                        class="export-btn rounded-lg secondary--text"
                        depressed
                        :href="exportLinks.receipt.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        block
                      >
                        <v-img class="ml-3" max-height="25" max-width="25" src="/img/icons/pdf.svg"></v-img>
                        PDF {{ receiptLabel }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="transactionsDialog" scrollable max-width="1200px" class="rounded-lg">
          <v-card class="rounded-lg">
            <v-toolbar flat class="ma-1 rounded-lg white--text" color="secondary" dark
              >{{ transactionLink.label }} های فاکتور
            </v-toolbar>
            <v-card-text class="mt-3">
              <v-simple-table>
                <thead>
                  <tr>
                    <th class="text-center">ردیف</th>
                    <th class="text-center">مبلغ</th>
                    <th class="text-center">کد دریافت/پرداخت</th>
                    <th class="text-center">تاریخ</th>
                    <th class="text-center">توضیحات</th>
                    <th class="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="item.payments && item.payments.length">
                    <tr v-for="(p, i) in item.payments" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-center">{{ p.value | toMoney }}</td>
                      <td class="text-center">{{ p.transaction.code }}</td>
                      <td class="text-center">{{ p.transaction.date }}</td>
                      <td class="text-center">{{ p.transaction.explanation }}</td>
                      <td class="text-center">
                        <v-btn depressed @click="openTransaction(p.transaction)" class="success white--text rounded-lg">
                          مشاهده {{ transactionLink.label }}
                          <v-icon class="mr-2">fa-eye</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    <tr class="back">
                      <td class="success--text text-center">جمع :</td>
                      <td class="text-center">{{ paymentsSum | toMoney }}</td>
                      <td colspan="4"></td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="4" class="text-center">موردی برای نمایش وجود ندارد</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>

      <template #footer-outside-btns>
        <v-btn
          v-show="false"
          v-if="id && !isFpi && !isPreFactor && !isRoR"
          @click="defineItem"
          :disabled="item.is_defined"
          depressed
          class="accent white--text mr-2 rounded-lg"
          >قطعی کردن فاکتور
        </v-btn>

        <v-btn
          id="pre-to-factor-btn"
          v-if="isPreFactor && !isEditing"
          @click="convertPreFactorToFactor"
          depressed
          class="secondary white--text mr-2 rounded-lg"
          >تبدیل به فاکتور
        </v-btn>

        <template v-if="isRoR && !isEditing">
          <v-btn
            depressed
            @click="convertRoRToFactor(RoRFactorTypes[type].factor.type)"
            class="secondary white--text mr-2 rounded-lg"
            >تبدیل به فاکتور {{ RoRFactorTypes[type].factor.label }}
          </v-btn>
          <v-btn
            @click="convertRoRToFactor(RoRFactorTypes[type].backFactor.type)"
            class="secondary white--text mr-2 rounded-lg"
            depressed
            >تبدیل به فاکتور {{ RoRFactorTypes[type].backFactor.label }}
          </v-btn>
        </template>

        <template v-if="item.in_moadian && !isEditing">
          <v-btn
              :to="to(item)"
              target="_blank"
              depressed
              class="submit secondary w-150px mt-1 mt-md-0 rounded-lg mr-5"
          >
            اطلاعات مؤدیان
          </v-btn>
          <v-btn
              v-if="!is_invoked"
              @click="updateMoadian(item.id)"
              depressed
              class="submit secondary w-150px mt-1 mt-md-0 rounded-lg mr-1"
          >
            ارسال اصلاح به مودیان
          </v-btn>
        </template>

      </template>
    </m-form>

    <v-dialog v-if="priceWare" v-model="pricesDialog" scrollable max-width="1000px" class="rounded-lg">
      <v-card class="rounded-lg">
        <v-card-title>آخرین قیمت های {{ priceWare.name }} برای {{ item.account.name }}</v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <m-datatable
                :headers="pricesHeaders"
                api-url="reports/buySale"
                :filters.sync="pricesFilters"
                :item-per-page="5"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="calculatorDialog" max-width="500px" transition="dialog-transition" class="rounded-lg">
      <v-card class="rounded-lg">
        <v-card-title>ورود طول و عرض و ارتفاع</v-card-title>

        <v-card-text v-if="row">
          <v-row>
            <v-col cols="12" md="4">
              <money label="قطر" v-model="row.meta.diameter" class="text-field-ltr" />
            </v-col>
            <v-col cols="12" md="4">
              <money label="طول" v-model="row.meta.length" class="text-field-ltr" />
            </v-col>
            <v-col cols="12" md="4">
              <money label="عرض" v-model="row.meta.width" class="text-field-ltr" />
            </v-col>
            <v-col cols="12" md="8">
              <money label="تعداد" v-model="row.meta.count" class="text-field-ltr" />
            </v-col>
            <v-col cols="12" md="4">
              <v-switch inset color="success" label="مقدار ثابت" v-model="row.meta.static_value"></v-switch>
            </v-col>
            <v-col cols="12" md="6">
              <money label="متر مربع" :value="squareMetters" class="text-field-ltr" disabled />
            </v-col>
            <v-col cols="12" md="6">
              <money label="متر مربع کل" :value="totalSquareMetters" class="text-field-ltr" disabled />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="setCalculatorData(row)" class="primary white--text w-100px rounded-lg">تایید</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="discountDialog" max-width="500px" class="rounded-lg">
      <v-card class="rounded-lg">
        <v-toolbar flat class="rounded-lg white--text" color="secondary" dark>تخفیف کلی</v-toolbar>

        <v-card-text>
          <v-row class="mt-5">
            <v-col cols="12" md="9">
              <v-text-field
                class="rounded-lg"
                type="number"
                min="0"
                max="100"
                step="1"
                prefix="%"
                @change="discountPercent = Math.max(Math.min(Math.round(discountPercent), 100), 0)"
                v-model="discountPercent"
                placeholder="درصد"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-btn
                block
                depressed
                @click="addDiscount"
                class="primary white--text rounded-lg pt-5 pb-5"
                :disabled="!isEditing"
                >اعمال تخفیف
              </v-btn>
            </v-col>
            <v-col cols="12" md="12" class="text-center font-weight-bold secondary--text">
              <v-icon class="primary--text">fa-info-circle</v-icon>
              درصد تخفیف در تمام ردیف ها اعمال میگردد
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="personDialog"
        class="rounded-lg"
        persistent
        max-width="90%"
    >
      <v-card class="rounded-lg">
        <v-card-text>
          <v-tabs class="rounded-lg white--text"
                  background-color="lightSecondary" color="primary">
            <v-tab class="white--text mr-2" active-class="secondary mr-2">
              <span> اشخاص</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> جاری شرکا دریافنتی</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> جاری شرکا پرداختنی</span>
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn icon fab color="white" class="mt-1 ml-2" @click="personDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="p"></accounts>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="r"></accounts>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="a"></accounts>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import FormLogic from "./FormLogic";
import { Icon } from "@progress/kendo-vue-common";
import FactorTabs from "@/views/panel/factor/FactorTabs";
import Accounts from '@/views/panel/account/Accounts.vue';

export default {
  name: "Form",
  components: { FactorTabs, Icon, Accounts },
  mixins: [FormLogic],
  data() {
    return {
      is_invoked: false,
    }
  },
  watch: {
    item(){
      if(this.item.in_moadian) {
        this.getInvoiceSubjectStatus(this.item.id)
      }
    }
  },
  methods: {
    to(item) {
      return {
        name: "MoadianFactorDetail",
        params: {
          id: item.id,
        },
      };
    },
    updateMoadian(factorId) {
      this.request({
        url: this.endpoint("moadian/keysan/updateFactor/"),
        method: "post",
        data: {
          factorId: factorId,
        },
        success: (data)=> {
          if (data[factorId]['success'] == true) {
            this.successNotify()
          } else if (data[factorId]['success'] == false) {
            this.notify(data[factorId]['message'], 'danger')
          }
        }
      })
    },
    getInvoiceSubjectStatus(factorId) {
      this.request({
        url: this.endpoint("moadian/keysan/invoiceSubjectStatus/" + factorId + '/'),
        method: "get",
        success: (data)=> {
          // if subject == 'ابطالی' && status == 'درج در کارپوشه'
          this.is_invoked = data['invoice_subject'] == 3 && data['status'] == 14
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
.finals {
  td:first-child {
    text-align: right !important;
  }

  td:last-child {
    text-align: left !important;
  }
}

.custom-checkbox {
  padding-left: 0px;
  margin-left: 0px;
}

.v-list-item {
  min-height: 30px !important;
}

#factor-person-btn{
  margin-top: 16px;
}
</style>

<style lang="scss">
#input-table {
  table {
    table-layout: fixed;

    th {
      padding: 0;
    }
  }
}
</style>
